import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ProcessDurationAppraiseeStage} from "../../../../models/process-models";
import { TreeViewEntity } from "../../../../models/tree-view-entity.model";

export class ProcessReportModel extends FormGroup{
    constructor(){
        super({
            BusinessUnit: new FormControl(),
            Employee:new FormControl(),
            StartDate: new FormControl(new Date(),Validators.required),
            EndDate: new FormControl(new Date(),Validators.required),
            Stages: new FormControl(null)
        })
        let startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 1);
        this.controls.StartDate.patchValue(startDate);
    }

    get BusinessUnit (){
        return this.controls.BusinessUnit.value;
    }

    set BusinessUnit (val: TreeViewEntity){
        this.controls.BusinessUnit.patchValue(val);
    }

    get Employee (){
        return this.controls.Employee.value;
    }

    set Employee (val){
        this.controls.Employee.patchValue(val);
    }

    get StartDate(){
        return this.controls.StartDate.value;
    }

    set StartDate(val: Date){
        this.controls.StartDate.patchValue(val);
    }
    
    get EndDate(){
        return this.controls.EndDate.value;
    }
    
    set EndDate(val: Date){
        this.controls.EndDate.patchValue(val);
    }

    get Stages(){
        return this.controls.Stages.value;
    }

    set Stages(val: ProcessDurationAppraiseeStage[]){
        this.controls.Stages.patchValue(val);
    }
}